module.exports = __webpack_public_path__ + "static/media/mozart.d27418f4.png";